import { topicsData } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热门话题</h2>
          <p className="text-foreground-600">站内影迷热议的影视话题，加入讨论发现更多好片</p>
        </div>

        <div className="max-w-4xl mx-auto flex flex-wrap justify-center gap-3">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href="#topics"
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-50 border border-background-200/60 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer no-underline group"
            >
              {topic.hot && (
                <i className="ri-fire-line text-primary-500 text-sm"></i>
              )}
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-500 transition-colors">{topic.name}</span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}